import { useLayoutEffect, useState } from "react";

export function useMeta() {
  const [meta, setMeta] = useState({ title: '', history: [], actions: [] });

  useLayoutEffect(() => {
    const handleEvent = (e) => {
      setMeta({
        title: e.detail?.title || null,
        history: (e.detail?.history || []),
        actions: (e.detail?.actions || []),
      });
    };

    window.addEventListener('metachange', handleEvent);
    return () => window.removeEventListener('metachange', handleEvent);
  }, [setMeta]);

  return meta;
}
